import { formatPattern } from "react-router-utils";
import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import Link from "app/components/UI/Link";
import PropTypes from "prop-types";
import React from "react";
import classes from "./MiniCart.module.css";

export const MiniCart = ({ clubId, articleIds }) =>
  clubId !== "checkout_response" && (
    <Link to={formatPattern("/:clubId/checkout", { clubId: clubId })}>
      <Flex direction="row" middle>
        {articleIds.size ? <div className={classes.miniCart__badge}>{articleIds.size}</div> : ""}
        <Icon className={classes.miniCart__icon}>shopping_cart</Icon>
      </Flex>
    </Link>
  );

MiniCart.propTypes = {
  clubId: PropTypes.string.isRequired
};

export default MiniCart;



// WEBPACK FOOTER //
// ./src/app/components/MiniCart/MiniCart.js